app.controller('modalEWaybillUploadCtrl', function ($scope, $uibModalInstance, Upload, urlServices, toaster, modalService, modalFactory, params) {
    var token = urlServices.ambilToken();

    $scope.title = params && params.title ? params.title : 'Upload E-Waybill';
    $scope.entryLabel = params && params.entryLabel ? params.entryLabel : 'E-Waybill';
    $scope.uploadFile = null;
    $scope.uploading = false;
    $scope.precheckResult = null;
    $scope.uploadResult = null;
    $scope.templateUrl = '';
    $scope.selectedShipper = null;

    $scope.showListCustomer = function () {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'customerList',
            params: {
                isReceiver: false,
                is_e_waybill: true,
                customerListUrl: 'api/e-waybill/customer-list?'
            }
        });
    };

    $scope.$on('pilih-contact', function (event, args) {
        if (args && !args.isReceiver) {
            $scope.selectedShipper = args;
        }
    });

    function refreshTemplateUrl() {
        token = urlServices.ambilToken();
        var url = params && params.templateUrl ? params.templateUrl : '';
        if (url) {
            url += (url.indexOf('?') >= 0 ? '&' : '?') + 't=' + encodeURIComponent(token || '');
        }
        $scope.templateUrl = url;
    }

    function normalizeApiError(response) {
        if (!response) {
            return 'Error tidak terdeteksi';
        }
        if (response.data && response.data.err) {
            return response.data.err;
        }
        if (response.data && typeof response.data === 'string') {
            return response.data;
        }
        return response.statusText || 'Error tidak terdeteksi';
    }

    function normalizeApiBody(response) {
        return response && response.data ? response.data : null;
    }

    function getUploadHeaders() {
        token = urlServices.ambilToken();
        return token ? {
            'my-token': token
        } : {};
    }

    function showConfirm(modalOptions, onConfirm, onCancel) {
        modalService.showModal({}, angular.extend({
            closeButtonText: 'Batal',
            actionButtonText: 'Ya'
        }, modalOptions || {})).then(function (confirmed) {
            if (confirmed && onConfirm) {
                onConfirm();
            }
        }, function () {
            if (onCancel) {
                onCancel();
            }
        });
    }

    function executeUpload() {
        if (!$scope.selectedShipper) {
            return toaster.pop('warning', $scope.entryLabel, 'Pilih Customer terlebih dahulu');
        }

        $scope.uploading = true;
        $scope.uploadResult = null;

        return Upload.upload({
            url: params.uploadUrl,
            withCredentials: true,
            headers: getUploadHeaders(),
            data: {
                file: $scope.uploadFile,
                shipper_code: JSON.stringify($scope.selectedShipper)
            }
        }).then(function (response) {
            var body = normalizeApiBody(response);

            $scope.uploading = false;
            if (!(response && response.status === 200 && body && body.valid)) {
                return toaster.pop('error', $scope.entryLabel, normalizeApiError(response));
            }

            $scope.uploadResult = body.dt || null;
            toaster.pop('success', $scope.entryLabel, (($scope.uploadResult && $scope.uploadResult.successCount) || 0) + ' data berhasil diupload');

            if ($scope.uploadResult && $scope.uploadResult.successCount > 0) {
                showConfirm({
                    headerText: 'Cetak ' + $scope.entryLabel,
                    bodyText: $scope.uploadResult.successCount + ' data berhasil diupload. Cetak semua E-Waybill yang baru diupload?'
                }, function () {
                    var successAwbs = ($scope.uploadResult.items || []).filter(function (item) {
                        return item && item.success && item.awb;
                    }).map(function (item) {
                        return item.awb;
                    });

                    if (successAwbs.length > 0) {
                        // Memanggil fungsi batch print dengan layout single
                        urlServices.simpanData('api/e-waybill/request-print-batch', {
                            awbs: successAwbs,
                            reason: 'CETAK HASIL UPLOAD',
                            single_layout: true
                        }, function (err, result) {
                            if (err) {
                                return toaster.pop('warning', $scope.entryLabel, err.err || err || 'Permintaan print gagal');
                            }
                            if (result && result.printUrl) {
                                window.open(result.printUrl, '_blank');
                            }
                        });
                    }
                });
            }
        }, function (response) {
            $scope.uploading = false;
            toaster.pop('error', $scope.entryLabel, normalizeApiError(response));
        });
    }

    function runPrecheck() {
        if (!$scope.selectedShipper) {
            return toaster.pop('warning', $scope.entryLabel, 'Pilih Customer terlebih dahulu');
        }

        $scope.uploading = true;
        $scope.precheckResult = null;
        $scope.uploadResult = null;

        return Upload.upload({
            url: params.precheckUrl,
            withCredentials: true,
            headers: getUploadHeaders(),
            data: {
                file: $scope.uploadFile,
                shipper_code: JSON.stringify($scope.selectedShipper)
            }
        }).then(function (response) {
            var body = normalizeApiBody(response);
            var precheckResult;

            $scope.uploading = false;
            if (!(response && response.status === 200 && body && body.valid)) {
                return toaster.pop('error', $scope.entryLabel, normalizeApiError(response));
            }

            precheckResult = body.dt || null;
            $scope.precheckResult = precheckResult;

            if (precheckResult && precheckResult.canUpload) {
                showConfirm({
                    headerText: 'Upload ' + $scope.entryLabel,
                    bodyText: 'Data valid. Lanjutkan upload ' + (precheckResult.readyCount || 0) + ' baris?'
                }, function () {
                    executeUpload();
                });
            } else if (precheckResult && precheckResult.failedCount > 0) {
                toaster.pop('warning', $scope.entryLabel, 'Terdapat ' + precheckResult.failedCount + ' baris data yang belum valid. Periksa kembali file anda.');
            }
        }, function (response) {
            $scope.uploading = false;
            toaster.pop('error', $scope.entryLabel, normalizeApiError(response));
        });
    }

    $scope.getResultItems = function () {
        if ($scope.uploadResult && $scope.uploadResult.items) {
            return $scope.uploadResult.items;
        }
        if ($scope.precheckResult && $scope.precheckResult.items) {
            return $scope.precheckResult.items;
        }
        return [];
    };

    $scope.resetResult = function () {
        $scope.uploadFile = null;
        $scope.precheckResult = null;
        $scope.uploadResult = null;
    };

    $scope.submitUpload = function () {
        if (!$scope.uploadFile) {
            return toaster.pop('warning', $scope.entryLabel, 'Pilih file Excel terlebih dahulu');
        }

        return runPrecheck();
    };

    $scope.printAwb = function (awb) {
        if (!awb || awb === '(auto)') {
            return;
        }
        urlServices.simpanData('api/e-waybill/' + encodeURIComponent(awb) + '/request-print', {
            reason: 'CETAK HASIL UPLOAD'
        }, function (err, result) {
            if (err) {
                return toaster.pop('warning', $scope.entryLabel, (err.err || err || 'Permintaan print gagal') + ' (' + awb + ')');
            }
            if (result && result.printUrl) {
                window.open(result.printUrl, '_blank');
            }
        });
    };

    $scope.close = function () {
        return $uibModalInstance.close($scope.uploadResult || null);
    };

    $scope.cancel = function () {
        return $uibModalInstance.dismiss('cancel');
    };

    refreshTemplateUrl();
});